import React from 'react';
import { ProfileQL } from '../../models/Profile';
import { Link } from 'react-router-dom';
import moment from 'moment';

import './titlebar.scss';

function SectionCertWarning({ currentUser }: { currentUser: ProfileQL }) {
    const billStatus = currentUser.billing ? currentUser.billing : null;
    const fpStatus = !!currentUser.fiscalpopProfileStatus ? currentUser.fiscalpopProfileStatus : null;
    const fpTimingErr = !fpStatus ? false : (!!fpStatus.notBefore && (new Date(fpStatus.notBefore).getTime() > Date.now())) || (!!fpStatus.notAfter && (new Date(fpStatus.notAfter).getTime() < Date.now()));

    if (!fpStatus && !billStatus) {
        return <div className="__titleMessage _empty"></div>;
    } else if (!billStatus && fpStatus && fpStatus.modulusMatch && !fpTimingErr) {
        if (currentUser.amazonProfile.selfBillingEnabled && (!currentUser.amazonProfile.defaultClaveSatProdServ || !currentUser.amazonProfile.defaultUnidadSat)) {
            const noDefaultsButDoesLink = `Es necesario agregar claves de producto y unidad predeterminadas para evitrar problemas al facturar en linea`;
            return (
                <div className="__titleMessage">
                    <Link to="/setup">
                        <p>
                            {noDefaultsButDoesLink}
                        </p>
                    </Link>
                </div>
            )
        }
        return <div className="__titleMessage _empty"></div>;
    }
    const disabledWarning = `Oops! le falta crédito a tu cuenta! agrega mas para poder facturar`;
    const certWarning = `Necesita subir su certificado CSD para facturar`;
    const keyWarning = `Necesita subir su llave de su CSD para facturar`;
    const bothWarning = `Necesita subir su llave y certificado CSD para continuar`;
    const notYetWarning = `El CSD todavia no puede ser usado, espere hasta el ${moment(new Date(fpStatus.notBefore || Date.now()).getTime()).format('dddd, MMMM Do YYYY, h:mm:ss a')}`;
    const notAnymoreWarning = `El CSD ya no es valido, venció el ${moment(new Date(fpStatus.notAfter || Date.now()).getTime()).format('dddd, MMMM Do YYYY, h:mm:ss a')}`;
    const modulusWarning = `Su llave no coincide con su certificado CSD, es necesario agregar los archivos correctos`;

    let finalLabel;
    let urlDestination = '/setup?showcerts=true';
    if (!!billStatus && !billStatus.enabled) {
        finalLabel = disabledWarning;
        urlDestination = '/account';
    } else if (!fpStatus.cerModulus && !fpStatus.keyModulus) {
        finalLabel = bothWarning;
    } else if (!fpStatus.cerModulus) {
        finalLabel = certWarning;
    } else if (!fpStatus.keyModulus) {
        finalLabel = keyWarning;
    } else if (!!fpStatus.notBefore && (new Date(fpStatus.notBefore).getTime() > Date.now())) {
        finalLabel = notYetWarning;
    } else if (!!fpStatus.notAfter && (new Date(fpStatus.notAfter).getTime() < Date.now())) {
        finalLabel = notAnymoreWarning;
    } else {
        finalLabel = modulusWarning;
    }

    return (
        <div className="__titleMessage">
            <Link to={urlDestination}>
                <p>
                    {finalLabel}
                </p>
            </Link>
        </div>
    )
}

function SectionTitleBar({ currentUser, title }: { currentUser: ProfileQL, title: string }) {

    return (
        <div className="__titleBar">
            <h3>{title}</h3>
            <SectionCertWarning currentUser={currentUser} />
        </div>
    )
}

export default SectionTitleBar;